const transformSourceIntoPlatform = (input) => {
  let result = ''
  if (!input) { return result }

  const word = input.split('-')
  if (word[0].includes('sekolahmu')) {
    result = 'sekolahmu'
  } else if (word[0].includes('kariermu')) {
    result = 'kariermu'
  } else {
    result = word[0]
  }
  return result
  // contoh result, input: kariermu-web; output: kariermu
  // contoh result, input: rencanamu-web; output: rencanamu
}

export default transformSourceIntoPlatform
